import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { useNavigate, useParams } from 'react-router-dom'
import { DraftContext } from '../../../../../../contexts/DraftContext'
import DraftStatusBadge from '../../../../../Shared/DraftStatusBadge'
import { PROVIDER_ICONS, PROVIDER_COLORS, actionTypeLabel } from '../../../../../../utils/actionDisplay'
import { clientFeedbackSentOverride } from '../../../../../../utils/draftStatus'
import { useReadOnly } from '../../../../../../contexts/ReadOnlyContext'

export default observer(function ActionItem({ action }) {
  const { id, action_id } = useParams()
  const readOnly = useReadOnly()
  const navigate = useNavigate()
  const { draftState } = useContext(DraftContext)
  const isActive = action_id && +action_id === +action.id
  const Icon = PROVIDER_ICONS[action.provider]
  const statusOverride = clientFeedbackSentOverride('pm', action.action_draft?.draft_status, action.action_draft?.latestVersion?.client_feedback_submitted)

  return (
    <div
      className={`flex items-center gap-2 p-2 rounded-lg mb-1 cursor-pointer ${
        isActive
          ? 'border-2 border-rb-green dark:border-rb-green bg-rb-soft-green dark:bg-rb-dark-mode-lighter'
          : 'border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter hover:bg-gray-50 dark:hover:bg-rb-dark-mode-lighter'
      }`}
      onClick={() => navigate(`/project_manager/campaigns/${id}/content_drafts/participants/${action.influencer_id}/actions/${action.id}`)}
    >
      {Icon && <Icon className={`shrink-0 ${PROVIDER_COLORS[action.provider]}`} />}

      <span className="text-sm truncate dark:text-white">
        {action.name}
        <span className="text-rb-mat-grey dark:text-rb-dark-mode-text-grey"> - {actionTypeLabel(action.action_type)}</span>
      </span>

      <DraftStatusBadge draftStatus={action.action_draft?.draft_status} className="ml-auto shrink-0" {...statusOverride} />

      {!readOnly && (
        <input
          type="checkbox"
          className="shrink-0 text-rb-green rounded-sm border-1 border-rb-black focus:ring-transparent"
          checked={draftState.isActionSelected(action.id)}
          onClick={e => e.stopPropagation()}
          onChange={() => draftState.toggleActionSelected(action.id)}
        />
      )}
    </div>
  )
})
